import MobFull from '@/rebuild/materials/shared/main_business/MobFull.vue';
import Overview from '@/rebuild/materials/shared/main_business/FullIndex.vue';

export const componentMap = {
	overview: Overview,
	'mob-full': MobFull
};
